import { IconType } from 'react-icons';

// Wrapper to fix react-icons v5 TypeScript compatibility
export const Icon = ({ icon: IconComponent, className }: { icon: IconType; className?: string }) => {
    return <>{IconComponent({ className })}</>;
};
